import { ROOT_URL } from '../shared/helpers/constants';

export const getImageUrl = (url) => {
  return `${ROOT_URL}${url}`;
};

export const test = '';
